exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-navigation {\n  text-align: center;\n  padding-top: 1rem;\n}\n.VueCarousel-navigation-button {\n  display: contents;\n}\n.step-controller {\n  font-size: 2rem;\n  color: #007bff;\n}\n.VueCarousel-navigation--disabled .step-controller {\n  opacity: .5;\n}\n", ""]);

// exports
